// eslint-disable-next-line no-unused-vars
import { Trip } from '@clients/myTrips'

const DATE_MAX_MS = 8640000000000000

export function findEarliestTripInList (trips: Trip[]) {
  return trips.reduce((earliest, next) => {
    const earliestTime = new Date(earliest.startInfo.timestamp)
    const nextTime = new Date(next.startInfo.timestamp)
    return earliestTime < nextTime ? earliest : next
  })
}

export function findLatestTripInList (trips: Trip[]) {
  return trips.reduce((latest, next) => {
    const latestTime = !latest.endInfo?.timestamp
      ? new Date(DATE_MAX_MS)
      : new Date(latest.endInfo.timestamp)
    const nextTime = !latest.endInfo?.timestamp
      ? new Date(DATE_MAX_MS)
      : new Date(next.endInfo.timestamp)

    return latestTime > nextTime ? latest : next
  })
}

